module.exports = __webpack_public_path__ + "static/freiraum1-60535f9b6a5d96311ea26833dc433895.png";